// components/payment/StripeProvider.js
import React from 'react';
import { loadStripe } from '@stripe/stripe-js';
import { Elements } from '@stripe/react-stripe-js';

// Initialize Stripe with your publishable key from environment variables
const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY);

const StripeProvider = ({ children, clientSecret }) => {
  // Ensure we have a client secret
  if (!clientSecret) {
    // Return a loading state instead of trying to render Elements without a clientSecret
    return (
      <div className="p-4 bg-blue-50 border border-blue-200 rounded-lg text-blue-600 flex items-center">
        <div className="animate-spin rounded-full h-5 w-5 border-b-2 border-blue-600 mr-3"></div>
        <span>Loading payment form...</span>
      </div>
    );
  }
  
  // Configuration with client secret
  const options = {
    clientSecret,
    appearance: {
      theme: 'stripe',
      variables: {
        colorPrimary: '#0366d6',
        colorBackground: '#ffffff',
        colorText: '#30313d',
        colorDanger: '#df1b41', 
        fontFamily: 'system-ui, -apple-system, sans-serif',
        spacingUnit: '4px',
        borderRadius: '8px',
      },
    },
  };

  return (
    <Elements stripe={stripePromise} options={options}>
      {children}
    </Elements>
  );
};

export default StripeProvider;